import { LOCALE_NAMES, LOCALES, useI18n } from "../i18n/index.ts";

/**
 * Bascule de langue. Comme le sélecteur de fond de carte, le bouton montre ce
 * vers quoi il fait basculer et non l'état courant — c'est ce que l'on cherche
 * quand on le regarde.
 */
export const LocaleToggle = (): React.ReactElement => {
  const { locale, setLocale, t } = useI18n();
  const next = LOCALES.find((candidate) => candidate !== locale) ?? locale;

  return (
    <button
      type="button"
      className="button button--round button--code"
      aria-label={t.localeSwitch(LOCALE_NAMES[next])}
      title={LOCALE_NAMES[next]}
      onClick={() => setLocale(next)}
    >
      <span aria-hidden="true">{next.toUpperCase()}</span>
    </button>
  );
};
